import { CustomModal } from "../../../../../../../../../../lib/CustomModal";
import { IImpoundSingle } from "../../../../../../../../../../types/Impounds";
import { DistributionForm } from "./DistributionForm";
import { useButtonHandlers } from "./hooks/useButtonHandlers";

type TDistributionModal = {
  impoundAccount: IImpoundSingle | null;
  isOpen: boolean;
  reloadData: () => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  parentId: string | null;
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
};

export const DistributionModal = ({
  impoundAccount,
  isOpen,
  reloadData,
  setIsOpen,
  parentId,
  payeesNumber
}: TDistributionModal) => {
  const { onCancelBtnClick } = useButtonHandlers({
    reloadData,
    setIsOpen,
    parentId
  });

  return (
    <CustomModal
      isModalOpen={isOpen}
      setIsModalOpen={onCancelBtnClick}
      titleText="Pay From Impound"
      width={318}
      headerClass="text w-500"
      modalClass="create-modal"
      destroyOnClose
    >
      <DistributionForm
        impoundAccount={impoundAccount}
        reloadData={reloadData}
        setIsOpen={setIsOpen}
        parentId={parentId}
        primaryBuyerNumber={payeesNumber.primaryBuyerNumber}
        primarySellerNumber={payeesNumber.primarySellerNumber}
      />
    </CustomModal>
  );
};
